<template>
  <v-expansion-panel>
      <v-expansion-panel-header>{{dayName}}
        <div>
          <div style="color: red; margin-left: 50px; float: left;" v-show="scheduleValid != 0">
            Each day part should have at least one playlist or channel.
          </div>
          <div style="color: red; margin-left: 50px; float:left;" v-show="timeValid != 0">
            Multiple day parts should not have same time
          </div>
          <div style="color: red; margin-left: 50px; float:left;" v-show="closeTime != 0">
            The Close time cannot be earlier than the latest daypart time
          </div>
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content >
        
        <v-data-table
          dense
          :headers="headers"
          :items-per-page="35"
          :items="dayParts"
          :hide-default-header="$vuetify.breakpoint.smAndDown"
          hide-default-footer
          no-data-text="No Schedule Selected"
          :item-class="addClass"
          item-key="id">
        <!-- Top here -->

        <template v-slot:item="{item}">
          <tr :class="'tr'+item.id" :id="'tr'+item.id">
            <td class="d-block d-sm-table-cell">
              <v-chip
              small
              color="green"
              v-if="dayParts.map(function(x) {return x.id; }).indexOf(item.id) == 0" style="color: #fff;">
              Open
              </v-chip>
              <v-chip 
              small
              color="red"
              v-else-if="dayParts.map(function(x){return x.id;}).indexOf(item.id) === dayParts.length - 1 && item.event_type == 0" style="color: #fff;">
              Closed
              </v-chip>
              <v-chip
              small 
              color="red"
              v-else-if="item.channel == 0 && item.playlist_name == null" style="color: #fff;">
              Day Part {{dayParts.map(function(x) {return x.id; }).indexOf(item.id) }}
              </v-chip>
              <v-chip
              small
              color="primary"
              v-else>
              Day Part {{dayParts.map(function(x) {return x.id; }).indexOf(item.id) }}
              </v-chip>
            </td>

            <td :id="'time'+item.id" class="d-block d-sm-table-cell" style="min-width: 150px;">
              <v-text-field
              style="margin: 5px 0px"
                :value="tConvert(item.start_time)"
                readonly
                solo
                dense
                hide-details
                @input="timeChange"
                append-icon="mdi mdi-menu-down"
                @click:append="openPicker(item)"
              ></v-text-field>
            </td>

            <td :id="'channel'+item.id" class="d-block d-sm-table-cell" >
               <p
              v-if="dayParts.map(function(x){return x.id;}).indexOf(item.id) === dayParts.length - 1" :style="$vuetify.breakpoint.smAndUp?'font-size: 16px; padding: 3px; margin: 0;':'font-size: 16px; padding: 3px; margin-top: 20px;'">
              Stops the audio stream until the next opening
              </p>

              <v-select 
              @change="channelChanged"
              v-else
              menu-props="auto"
              hide-details
              dense
              solo
              :items="channels"
              v-model="item.channel_number"
              item-value="channel_number"
              style="margin: 5px 0px">
              <template v-slot:selection="{item}">
                  ({{item.channel_number}}) {{item.name}}
              </template>
              <template v-slot:item="data">
                  <template v-if="typeof data.item !== 'object'">
                  <v-list-item-content v-text="data.item"></v-list-item-content>
                  </template>
                  <template v-else>
                  <v-list-item-content>({{data.item.channel_number}}) {{data.item.name}}</v-list-item-content>
                  </template>
              </template>
              </v-select>
            </td>

            <td class="d-block d-sm-table-cell" style="min-width: 128px;">
              <v-select
              :style="!(dayParts.map(function(x){return x.id;}).indexOf(item.id) != dayParts.length - 1) ? 'display: none':''"
              menu-props="auto"
              hide-details
              style="margin:5px 0px;"
              v-model="item.volume"
              dense
              solo
              item-text="volume"
              item-value="id"
              :items="volumes"
              @change="volumeChanged"
              >
              </v-select>
            </td>

            <td class="d-block d-sm-table-cell" v-if="$vuetify.breakpoint.smAndUp" >
              <v-divider
              :style="!(dayParts.map(function(x){return x.id;}).indexOf(item.id) != dayParts.length - 1) ? 'display: none':''" 
              vertical>
              </v-divider>
            </td>
   

            <td :id="'playlist'+item.id" class="d-block d-sm-table-cell" style="min-width: 200px;">
              <v-select 
              @change="playlistChanged"
              :style="!(dayParts.map(function(x){return x.id;}).indexOf(item.id) != dayParts.length - 1) ? 'display: none':''"
              menu-props="auto"
              hide-details
              dense
              solo
              :items="playlists"
              v-model="item.playlist_id"
              item-value="id"
              style="margin: 5px 0px">
              <template v-slot:selection="{item}">
                  <template v-if="item.id == -2">
                  {{item.name}}
                  </template> 
                  <template v-else>
                  {{item.name}} - {{item.duration}}
                  </template>
              </template>
              <template v-slot:item="data">
                 <template v-if="typeof data.item !== 'object'">
                  <v-list-item-content v-text="data.item"></v-list-item-content>
                  </template>
                  <template v-else-if="data.item.id == -2">
                  <v-list-item-content>{{data.item.name}}</v-list-item-content>
                  </template> 
                  <template v-else>
                  <v-list-item-content>{{data.item.name}} - {{data.item.duration}}</v-list-item-content>
                  </template>
                  
              </template>
              </v-select>
            </td>

            <td class="d-block d-sm-table-cell" style="min-width: 128px;">
              <v-select
              :style="!(dayParts.map(function(x){return x.id;}).indexOf(item.id) != dayParts.length - 1) ? 'display: none':''"
              menu-props="auto"
              hide-details
              style="margin:5px 0px"
              v-model="item.volume2"
              item-value="id"
              item-text="volume"
              dense
              solo
              :items="volumes"
              @change="volume2Changed"
              ></v-select>
            </td>

            <td class="d-block d-sm-table-cell" :class="$vuetify.breakpoint.smAndUp?'':'mt-4'">
              <v-icon
              small
              v-show="item.event_type && !(dayParts.map(function(x) {return x.id; }).indexOf(item.id) == 0)"
              @click="deleteItem(item)">
              delete
              </v-icon>
            </td>

          </tr>
        </template>
        
        </v-data-table>
        <div v-if="scheduleName == ''">
           
        <!-- <v-btn
        color="primary"
        dark
        tile
        @click.prevent="saveSchedule"
        height="20"
        :style="$vuetify.breakpoint.smAndDown?'height: 20px;font-size: 0.65rem;margin-left: 10px;float:right;':'font-size:0.650rem;float:right;margin-left: 10px;'"
        >Save Schedule</v-btn> -->
        <v-btn 
        class="ml-2"
        color="primary" 
        dark @click.prevent="addDayPart()" 
        height="20" 
        :style="$vuetify.breakpoint.smAndDown?'height:20px;font-size:0.65rem;':'font-size:0.650rem;'" 
        :disabled="!selectedSchedule" 
        tile>
            <v-icon size="15">add</v-icon>Day Part
        </v-btn>
        <v-btn 
          v-if="dayParts.length > 0"
          color="primary" 
          dark height="20" 
          max-width="135"
          :style="$vuetify.breakpoint.smAndDown?'height: 20px;font-size: 0.65rem; margin-left: 13%;':'font-size:0.650rem;margin-left: 1%;'" 
          tile @click.prevent="copyToAllDays" 
          :disabled="!selectedSchedule"><v-icon size="15">add</v-icon>Copy to all days</v-btn>
        
        </div>
        <div v-else>
        <v-btn 
          color="primary" 
          dark @click.prevent="addDayPart()" 
          height="20" 
          :style="$vuetify.breakpoint.smAndDown?'height: 20px;font-size: 0.65rem;float:right; margin-right:10px;':'font-size:0.650rem;float:right;'" 
          :disabled="!isValidForm" 
          tile>
          <v-icon size="15">add</v-icon>Day Part
        </v-btn>
        <v-btn
        color="primary"
        dark
        >Save Playlist</v-btn>
        <v-btn 
        v-if="dayParts.length > 0"
        color="primary" 
        dark height="20" 
        :style="$vuetify.breakpoint.smAndDown?'height: 20px;font-size: 0.65rem;margin-right: 10px;float:right;':'font-size:0.650rem;float:right;margin-right: 10px;'" 
        tile @click.prevent="copyToAllDays" 
        :disabled="!isValidForm"><v-icon size="15">add</v-icon>Copy to all days</v-btn>
        </div>

      <v-dialog 
            max-width="400"
            v-model="deleteDialog">
            <v-card tile>
                <v-card-title>Are you sure?</v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pa-6">
                    <p class="title">Do you want to delete this day part?</p>
                    <div v-if="shouldDeleteItem" class="user-info">
                        <p class="mb-1">Start Time : {{shouldDeleteItem.start_time}}</p>
                    </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click.prevent="deleteDialogClose" tile >No</v-btn>
                    <v-btn color="red accent-4" @click.prevent="confirmDelete" tile class="white--text">Yes</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                ref="dialog"
                v-model="modal2"
                :return-value.sync="currentTime"
                persistent
                width="290px"
              >

                <v-time-picker
                  ampm-in-title
                  v-if="modal2"
                  v-model="currentTime"
                  full-width
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="modal2 = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="timeChange"
                  >
                    OK
                  </v-btn>
                </v-time-picker>
              </v-dialog>
    
    </v-expansion-panel-content>
    </v-expansion-panel>

</template>
<script>
import axios from './axios'
import { v4 as uuidv4} from 'uuid'
import Volume from './../../../volumes'
export default {
    props:[
      'dayParts',
      'dayName',
      'selectedSchedule', 
      'channels',
      'dow',
      'getScheduleSettings', 
      'isValidForm', 
      'scheduleName',
      'playlists'
    ],
    data(){
        return {
            deleteDialog: false,
            shouldDeleteItem:null,
            volumes:Volume,
            isSaved: true,
            scheduleValid: 0,
            timeValid: 0,
            closeTime: 0,
            modal2: false,    
            currentTime: null,
            timeIndex: 0 
        }
    },
    methods:{
      openPicker(item){
          this.timeIndex = this.dayParts.indexOf(item)
          this.currentTime = item.start_time
          this.modal2 = true
        },
        timeChange(){
          this.dayParts[this.timeIndex].start_time = this.currentTime
          this.modal2 = false
          this.isSaved = false
          this.removeClass('time')
          this.timeValid = 0
          this.closeTime = 0
          this.saveSchedule()
        },
        tConvert(time) {
          // Check correct time format and split into components
          time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

          if (time.length > 1) { // If time format correct
            time = time.slice(1); // Remove full string match value
            time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
            time[0] = +time[0] % 12 || 12; // Adjust hours
          }
          return time.join(''); // return adjusted time or original string
        },
        playlistChanged(){
          this.isSaved = false
          this.removeClass('channel')
          this.removeClass('playlist')
          this.saveSchedule()
        },
        channelChanged(){
          this.isSaved = false
          this.removeClass('playlist')
          this.removeClass('channel')
          this.saveSchedule()
        },
        volumeChanged(){
          this.isSaved = false
          this.saveSchedule()
        },
        volume2Changed(){
          this.isSaved = false
          this.saveSchedule()
        },
        validate(){
          let valid = 0
          let time = new Set()
          let duplicateTimes = []
          this.dayParts.some(part=>{
            (time.size === time.add(part.start_time).size) ? duplicateTimes.push(part.start_time): ''
          })

          if(duplicateTimes.length > 0){
            duplicateTimes.forEach(duplicatetime=>{
            let targetedDaypart =  this.dayParts.filter(dp=>{return dp.start_time == duplicatetime })
              this.addClass(targetedDaypart, 'time')
            })
            valid = valid+1
            this.timeValid = 1
          }else{
            this.timeValid = 0
          }

          let no_channel_playlist = this.dayParts.filter(dp=>{return dp.channel_number == -2 && dp.playlist_id == -2 && dp.event_type != 0})
          if(no_channel_playlist.length > 0){
            this.removeClass('channel')
            this.addClass(no_channel_playlist, 'channel')
            this.removeClass('playlist')
            this.addClass(no_channel_playlist, 'playlist')
            valid = valid + 1
            this.scheduleValid = 1
          }else{
            this.scheduleValid = 0
          }

          if(this.dayParts.length > 0){
            var secondLast = this.dayParts[this.timeIndex]
            var last = this.dayParts[this.dayParts.length - 1]
            var secondLastTimeFloatValue = parseFloat(secondLast.start_time.replace(":", "."))
            var lastTimeFloatValue = parseFloat(last.start_time.replace(":", "."))

            if(lastTimeFloatValue < secondLastTimeFloatValue && secondLast.event_type == 1){
              valid = valid + 1
              this.closeTime = 1
              this.addClassSingleTime(secondLast, 'time')
              this.addClassSingleTime(last, 'time')
            }else if(secondLast.event_type == 0){
              var maxTime = Math.max.apply(Math, this.dayParts.map(function(item) { return parseFloat(item.start_time.replace(":", "."))}))
              if(secondLastTimeFloatValue < maxTime){
                valid = valid + 1
                this.closeTime = 1
                var stringTime = maxTime.toString()
                    if(stringTime.search(/\./) != -1){
                      var newStartTime = stringTime.replace(".", ":")
                      let maxItem = this.dayParts.filter(item=>{
                        return item.start_time == newStartTime
                      })
                      
                      this.addClass(maxItem, 'time')
                      this.addClassSingleTime(secondLast, 'time')
                    }else{
                      newStartTime = stringTime+":"+"00"
                      let maxItem = this.dayParts.filter(item=>{
                        return item.start_time == newStartTime
                      })
                      
                      this.addClass(maxItem, 'time')
                      this.addClassSingleTime(secondLast, 'time')
                    }
              }

            }else{
              this.closeTime = 0
            }

          }

          return valid
        },
        addClassSingleTime(item){
          let el = document.getElementById('time'+item.id)
          el.classList.add('time-error')
        },
        addClass(item, type){
          this.removeClass(type)
          for (let index = 0; index < item.length; index++) {
            let el = document.getElementById(type+item[index].id)
              el.classList.add(type+'-error')
          }
        },
        removeClass(type){
          if(this.dayParts.length > 0){
            this.dayParts.forEach(dp=>{
                let el = document.getElementById(type+dp.id)
                el.classList.remove(type+'-error')
            })
          }
        },
        saveSchedule(){
          let valid = this.validate()
          this.scheduleValid = valid
          if(valid == 0 && this.isSaved == false){
            this.isSaved = true
              let data = {
                dayparts: this.dayParts,
                schedule_id: this.selectedSchedule
              }

              axios.post('daypart', data, {
                params: {
                  token: this.$store.getters.getToken,
                  user_id: this.$store.getters.getUser
                }
              })
              .then(response=>{
                this.$store.dispatch('setAlert', response.data.message)
                this.getScheduleSettings(this.selectedSchedule)
                
              })
              .catch(error=>{
                this.$store.dispatch('setErrorAlert', error.response.data.message)
              })
          }
          
        },
        addDayPart(){
          this.isSaved = false
          let start_time = '08:00'
          if(this.dayParts.length > 0){
            //Find Next Start Time
            var secondLast = this.dayParts[this.dayParts.length - 2]
            var secondLastStartTime = secondLast.start_time
            var firstPartOfStartTime = secondLastStartTime.split(":")[0]
            var nextStartTime = parseInt(firstPartOfStartTime) + 1

            //Find Close Time
            var last = this.dayParts[this.dayParts.length - 1]
            var lastStartTime = last.start_time
            var firstPartOfCloseTime = lastStartTime.split(":")[0]
            var intCloseTime = parseInt(firstPartOfCloseTime)

            if(nextStartTime >= intCloseTime){
              this.$store.dispatch("setErrorAlert", "Day part can't be later time of close time.")
              return 
            }
              

            var nextStartTimeString = nextStartTime.toString()
            start_time = (nextStartTimeString.length == 1)? '0'+nextStartTimeString+':00' : nextStartTimeString+':00'
          }


          let start =  {
              command: 'play',
              channel_number: 0,
              playlist_id: -2,
              volume:100,
              volume2:100,
              dow: this.dow,
              name:'',
              repeat: 0,
              url:'',
              start_time: start_time,
              end_time:'',
              created_at:'',
              updated_at:'',
              id: uuidv4(),
              new: 1,
              event_type:1
            }
        
          let end = {
            command: 'stop',
            channel_number: 0,
            playlist_id: -2,
            volume:0,
            volume2:0,
            dow: this.dow,
            name:'',
            repeat:0,
            url:'',
            start_time:"23:59",
            end_time:'',
            created_at:'',
            updated_at:'',
            id:uuidv4(),
            new: 1,
            event_type: 0
          }

          if(this.dayParts.length == 0){
            this.dayParts.push(start)
            this.dayParts.push(end)
          }else{
            this.dayParts.splice(this.dayParts.length - 1, 0, start)
          }

         // this.saveSchedule()
        },
        deleteItem(item) {
          this.shouldDeleteItem = null
          this.shouldDeleteItem = item
          this.deleteDialog = true
        },
        confirmDelete(){
          const index = this.dayParts.indexOf(this.shouldDeleteItem)

          if(this.shouldDeleteItem.new == 1){
            this.dayParts.splice(index, 1)
            this.deleteDialog = false
            this.validate()
            this.$forceUpdate()
          }else{
            axios.delete('schedule/day-part/'+this.shouldDeleteItem.id+'?token='+this.$store.getters.getToken)
            .then(response=>{
              this.dayParts.splice(index, 1)
              if(this.dayParts.length == 1){
                this.dayParts.splice(0,1)
              }
              this.$store.dispatch('setAlert', response.data.message)
              this.deleteDialog = false
            })
            .catch(error=>{
                this.$store.dispatch('setErrorAlert', error.response.data.message)
            })

          }
          
        },
        deleteDialogClose(){
          this.shouldDeleteItem=null
          this.deleteDialog = false
        },
        copyToAllDays(){
          this.selectedSchedule = this.selectedSchedule?this.selectedSchedule:this.$store.getters.getNewScheduleId
          axios.post('schedule-setting-copy/'+this.selectedSchedule+'/'+this.dow+'?token='+this.$store.getters.getToken)
              .then(response=>{
                this.$store.dispatch('setAlert', response.data.message)
                this.getScheduleSettings(this.selectedSchedule)
              })
              .catch(error=>{
                  this.$store.dispatch('setErrorAlert', error.response.data.message)
              })
        },
    },
    updated(){
      this.validate()
    },
    computed:{
      headers(){ 
        let header =[]
        if(this.$vuetify.breakpoint.smAndDown){
          header = [
            { text: 'Time', value: 'start_time', sortable: false },
            { text: 'Channel', value: 'name', sortable: false },
            { text: 'Volume (%)', value: 'volume', sortable: false },
            { text: '', value: 'divider', sortable: false},
            { text: 'Message Playlist', value: 'playlist_name', sortable: false},
            { text: 'Volume (%)', value: 'volume2', sortable: false},
            { text: 'Actions', value: 'action', sortable: false },
          ]
        }else{
         header= [
            {
              text: 'Day Part',
              align: 'left',
              sortable: false,
              value: 'day_part',
              width: '6%'
            },
            { text: 'Time', value: 'start_time', sortable: false, width: '11%'},
            { text: 'Channel', value: 'name', sortable: false, with: '22%' },
            { text: 'Volume (%)', value: 'volume', sortable: false, width:'9%'},
            { text: '', value: 'divider', sortable: false, width: '1%'},
            { text: 'Message Playlist', value: 'playlist_name', sortable: false, width: '22%'},
            { text: 'Volume (%)', value: 'volume2', sortable: false, width: '9%'},
            { text: 'Actions', value: 'action', sortable: false, width: '5%'},
          ]
        }
        return header
      }
    }
}
</script>
<style>
  .v-expansion-panel-content__wrap{
    padding: 0 2px 16px;
  }
  .v-expansion-panel--active>.v-expansion-panel-header {
      min-height: 38px;
  }
  .v-expansion-panel-header{
    padding: 8px 24px;
  }

  .v-select__selections{
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }
</style>